import { useState } from 'react';
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import moment from 'moment';

interface IProps {
    startDate?: moment.Moment | null

    onClose: (endDate: moment.Moment | null) => void
}

let SetAvailable = ({ startDate, onClose }: IProps) => {

    let [endDate, setEndDate] = useState<moment.Moment | null>(null);


    let closeAndConfirm = () => {
        if (startDate != null && (endDate == null || (endDate != null && endDate.isBefore(startDate)))) {
            return;
        }
        onClose(endDate);
    }

    return (
        <Dialog open={true} fullWidth onClose={() => onClose(null)}>
            <DialogTitle>
                Imposta data rientro
            </DialogTitle>
            <DialogContent>

                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            Data di Inizio: {moment(startDate).format("DD/MM/YYYY")}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <DesktopDatePicker
                            label="Data Rientro"
                            value={endDate}
                            onChange={(value) => setEndDate(value != null ? moment(value) : null)}
                            renderInput={props => <TextField {...props} size="small" />}
                            inputFormat="DD/MM/YYYY"
                        />
                    </Grid>
                    {startDate != null && endDate != null && (endDate.isBefore(startDate)) &&
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" color="error">
                                La data di Rientro non pu&ograve; essere precedente alla data di Inizio ({moment(startDate).format("DD/MM/YYYY")})
                            </Typography>
                        </Grid>
                    }
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(null)} color="secondary" autoFocus>
                    Annulla
                </Button>
                <Button
                    autoFocus
                    onClick={() => closeAndConfirm()}
                    disabled={startDate != null && (endDate == null || (endDate != null && endDate.isBefore(startDate)))}
                >
                    Conferma
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SetAvailable;